'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tld = exports.hostname = undefined;

var _util = require('./util');

Object.defineProperty(exports, 'hostname', {
  enumerable: true,
  get: function get() {
    return _util.hostname;
  }
});
Object.defineProperty(exports, 'tld', {
  enumerable: true,
  get: function get() {
    return _util.tld;
  }
});

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _indexof = require('indexof');

var _indexof2 = _interopRequireDefault(_indexof);

var _sufeiSeed = require('@ali/sufei/build/app/common/sufei-seed');

var _sufeiSeed2 = _interopRequireDefault(_sufeiSeed);

var _errorCode = require('./error-code');

var _errorCode2 = _interopRequireDefault(_errorCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The parameters required to generate retcode
 * @param urlString{object} : axios response config data
 */
// ie8 polyfill
function getLocation(urlString) {
  var a = document.createElement('a');
  a.href = urlString;
  // fix ie origin & pathname
  if (!a.origin) {
    // Some browsers (mainly IE) does not have this property, so we need to build it manually...
    // if url is : '//xxxx.lazada.com' , a.protocol will return :
    if (a.protocol === '' || a.protocol === ':') {
      a.protocol = window.location.protocol || 'https:';
    }
    // IE default port number, need to remove http:80 / https:443
    a.origin = a.protocol + '//' + a.hostname + (a.port && (0, _indexof2.default)(['0', '80', '443'], a.port) === -1 ? ':' + a.port : '');
  }

  // pathname is special because IE takes the "/" of the starting of pathname
  a.newPathname = (a.pathname.charAt(0) !== '/' ? '/' : '') + a.pathname;

  return a;
}

var instance = _axios2.default.create();

if (document !== 'undefined') {
  var $tokenTag = document.head.querySelector('[name="X-CSRF-TOKEN"]');
  if ($tokenTag && $tokenTag.content) {
    instance.defaults.headers['X-CSRF-TOKEN'] = $tokenTag.content;
  }
}

// The url that flags the current request is an server api
instance.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

if (instance.defaults.errorCode && Array.isArray(instance.defaults.errorCode)) {
  instance.defaults.errorCode = _errorCode2.default.concat(instance.defaults.errorCode);
} else {
  instance.defaults.errorCode = _errorCode2.default;
}

// Add a request interceptor
instance.interceptors.request.use(function (config) {
  return new Promise(function (resolve) {
    var umidConfig = config.umid || {};
    var addCustomHeader = function addCustomHeader() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (data && data.ua && data.umidToken) {
        config.headers['x-ua'] = data.ua;
        config.headers['x-umidtoken'] = data.umidToken;
      } else {
        // @david david.chenz , doc : https://lark.alipay.com/aone676271/bi56i8/fpapi
        if (umidConfig.required !== false && window.Group_umid && window.Group_umid.getUA) {
          config.headers['x-ua'] = window.Group_umid.getUA();
        }
        if (umidConfig.required !== false && window.Group_umid && window.Group_umid.getUmidToken) {
          config.headers['x-umidtoken'] = window.Group_umid.getUmidToken();
        }
      }

      if (config.data && typeof config.data === 'string') {
        try {
          var uData = JSON.parse(config.data);
          if (uData['X-CSRF-TOKEN']) {
            config.headers['X-CSRF-TOKEN'] = uData['X-CSRF-TOKEN'];
          }
        } catch (e) {
          console.error(e);
        }
      }

      // start time when the request was sent
      config.retcodeStartTime = Date.now();
      resolve(config);
    };
    if (umidConfig.required !== false && window.umidTokenFromHeader) {
      // new version to get umidtoken and UA
      if (/defaultToken[1,2]/.test(window.umidTokenFromHeader) || /defaultUAFromHeader/.test(window.UAFromHeader)) {
        // not ready, wait timeout
        var timeout = umidConfig.timeout || 2000;
        setTimeout(function () {
          addCustomHeader({
            umidToken: window.umidTokenFromHeader,
            ua: window.uabModule && window.uabModule.getUA ? window.uabModule.getUA() : window.UAFromHeader
          });
        }, timeout);
      } else {
        addCustomHeader({
          umidToken: window.umidTokenFromHeader,
          ua: window.uabModule && window.uabModule.getUA ? window.uabModule.getUA() : window.UAFromHeader
        });
      }
    } else if (umidConfig.required !== false && window.Group_umid) {
      // old version to get umidtoken
      var _timeout = umidConfig.timeout || 2000;
      var hasAddCustomHeader = false;
      window.Group_umid.ready(function () {
        // if not ready, window.Group_umid.getUmidToken will get a fake token, isn't from backend, invalid
        if (!hasAddCustomHeader) {
          hasAddCustomHeader = true;
          addCustomHeader();
        }
      });
      setTimeout(function () {
        if (!hasAddCustomHeader) {
          hasAddCustomHeader = true;
          addCustomHeader();
        }
      }, _timeout);
    } else {
      addCustomHeader();
    }
  });
}, function (error) {
  return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
  return new Promise(function (resolve) {
    // api success
    var config = response.config;
    var location = getLocation(config.url);
    var retcodeConfig = config.retcode || {};
    var url = retcodeConfig.apiName || '' + location.origin + location.newPathname;
    var endTime = config.retcodeStartTime ? Date.now() - config.retcodeStartTime : 0;
    var retcodeHandler = function retcodeHandler() {
      // if user need disable retcode, can set disableDefaultRetcode = true
      if (config.disableDefaultRetcode) {
        resolve(response);
      }

      var msg = '';
      // response status is 200, but api return success=false
      // error code key in error-code file will report to retcode
      if (response.data && response.data.success === false && response.data.errorCode && response.data.errorCode.key && (0, _indexof2.default)(instance.defaults.errorCode, response.data.errorCode.key) !== -1) {
        // if have error message , it will report to retcode
        try {
          msg += JSON.stringify(response.data.errorCode);
        } catch (e) {
          msg += e.message;
        }

        if (location.search) {
          msg += ' query = ' + location.search;
        }
        window._blReport && window._blReport('api', [url, false, endTime, 'data-success-false', msg]);
      } else {
        // response 200 and api return success
        window._blReport && window._blReport('api', [url, true, endTime, 200, 'Successfully']);
      }
      resolve(response);
    };

    // if user need disable [sufei](https://yuque.antfin-inc.com/security-base/sufei/sufei-seed), can set disableDefaultSufei = true
    if (config.disableDefaultSufei) {
      retcodeHandler();
    } else {
      _sufeiSeed2.default.check(response.data, function (valid, data) {
        // intercepted by Baxia, handled by sufei on frontend
        if (!valid) {
          if (data && data._sufeiToken) {
            // pass verification, like passing slider verification
            // resend request
            window._blReport && window._blReport('api', [url, false, endTime, 'data-success-false', 'sufei intercepted, user pass verification, will resend request']);
            instance(config).then(function (resendRequestResponse) {
              resolve(resendRequestResponse);
            }).catch(function (err) {
              window._blReport && window._blReport('api', [url, false, endTime, 'data-success-false', 'sufei send request fail: ' + JSON.stringify(err)]);
            });
          } else {
            // haven't pass verification, like user close slider verification dialog directly
            window._blReport && window._blReport('api', [url, false, endTime, 'data-success-false', 'sufei intercepted, user haven\'t pass verification']);
            resolve(response);
          }
        } else {
          // normal request
          retcodeHandler();
        }
      });
    }
  });
}, function (error) {
  // response status return 500/401/... (not 20x)
  if (error && error.config) {
    var config = error.config;
    // if user need disable retcode
    if (config.disableDefaultRetcode) {
      return Promise.reject(error);
    }

    var endTime = config.retcodeStartTime ? Date.now() - config.retcodeStartTime : 0;
    var location = getLocation(config.url);
    var retcodeConfig = config.retcode || {};
    var url = retcodeConfig.apiName || '' + location.origin + location.newPathname;
    window._blReport && window._blReport('api', [url, false, endTime, 'server-error', error]);
  } else {
    window._blReport && window._blReport('api', ['api not found', false, Date.now(), 'api-not-found', error]);
  }
  return Promise.reject(error);
});
exports.default = instance;


// WEBPACK FOOTER //
// ./node_modules/_@ali_lzdmod-axios@2.1.2@@ali/lzdmod-axios/lib/index.js